import qs from 'qs';
import { AxiosRequestConfig } from 'axios';
import instance, { CRM_REPORT_API_URL } from 'api';
import {
  ApplicationKPIByCount,
  ApplicationKPIByQuality,
  ApplicationKPIBySpeed,
  IArea,
  IPosition,
  IRealEstate,
  IUser,
  IWorkType,
} from './interfaces';

// Count
export const getApplicationsKPIInfoByCountWorkType = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByCount.WorkType[]; totalCount: number }>('/kpi/application/listCount', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByCountWorkTypeView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByCount.WorkTypeView[]; totalCount: number }>('/kpi/application/listCount/view', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByCountWorkTypeExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listCount/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

export const getApplicationsKPIInfoByCountRoom = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByCount.Room[]; totalCount: number }>('/kpi/application/listCountRoom', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByCountDefectType = (
  dynamicBy: ApplicationKPIByCount.DefectTypeDynamicBy,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByCount.DefectType[]; totalCount: number }>(
      `/kpi/application/listCountDefectType${dynamicBy}`,
      {
        ...config,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      },
    )
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByCountDefectTypeView = (
  dynamicBy: ApplicationKPIByCount.DefectTypeDynamicBy,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByCount.DefectTypeView[]; totalCount: number }>(
      `/kpi/application/listCountDefectType${dynamicBy}/view`,
      {
        ...config,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      },
    )
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByCountDefectTypeExcel = (
  dynamicBy: ApplicationKPIByCount.DefectTypeDynamicBy,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listCountDefectType${dynamicBy}/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

// Quality
export const getApplicationsKPIInfoByQualityAct = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.Act[]; totalCount: number }>(`/kpi/application/listQualityAct`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityActView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.ActView[]; totalCount: number }>(`/kpi/application/listQualityAct/view`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityActExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listQualityAct/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

export const getApplicationsKPIInfoByQualityDelay = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.Delay[]; totalCount: number }>(`/kpi/application/listQualityDelay`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityDelayView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.DelayView[]; totalCount: number }>(`/kpi/application/listQualityDelay/view`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityDelayExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listQualityDelay/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

export const getApplicationsKPIInfoByQualityMark = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.Mark[]; totalCount: number }>(`/kpi/application/listQualityMark`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityMarkView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.MarkView[]; totalCount: number }>(`/kpi/application/listQualityMark/view`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityMarkExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listQualityMark/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

export const getApplicationsKPIInfoByQualityReopen = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.Reopen[]; totalCount: number }>(`/kpi/application/listQualityReopen`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityReopenView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIByQuality.ReopenView[]; totalCount: number }>(
      `/kpi/application/listQualityReopen/view`,
      {
        ...config,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      },
    )
    .then((response) => response.data);
};

export const getApplicationsKPIInfoByQualityReopenExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listQualityReopen/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

// Speed
export const getApplicationsKPIInfoBySpeedDone = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIBySpeed.Done[]; totalCount: number }>(`/kpi/application/listSpeedDone`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoBySpeedDoneView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIBySpeed.DoneView[]; totalCount: number }>(`/kpi/application/listSpeedDone/view`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoBySpeedDoneExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listSpeedDone/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

export const getApplicationsKPIInfoBySpeedInProgress = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIBySpeed.InProgress[]; totalCount: number }>(`/kpi/application/listSpeedInProgress`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsKPIInfoBySpeedInProgressView = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: ApplicationKPIBySpeed.InProgressView[]; totalCount: number }>(
      `/kpi/application/listSpeedInProgress/view`,
      {
        ...config,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      },
    )
    .then((response) => response.data);
};

export const getApplicationsKPIInfoBySpeedInProgressExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/kpi/application/listSpeedInProgress/export`, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response);
};

// dictionaries
export const getPositions = () => {
  return instance()
    .post<IPosition[]>('/dictionary/positions')
    .then((response) => response.data);
};

export const getUsers = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IUser[]>('/users/listPerformance', { search: config?.params.search }, config)
    .then((response) => response.data);
};

export const getAreas = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IArea[]>('/kpi/application/listArea', config)
    .then((response) => response.data);
};

export const getRealEstates = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IRealEstate[]>('/kpi/application/listRealEstate', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getWorkTypes = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IWorkType[]>('/kpi/application/listWorkType', config)
    .then((response) => response.data);
};
